// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"474":"5e5db9a7","559":"5fef70a0","637":"caec34f8","772":"f6f8489e","787":"d16d0675","989":"38689c48"}[chunkId] + ".chunk.js";
};